import WhatInput from 'what-input';
/**
 * Returns interaction device.
 *
 * @returns Interaction device.
 */
export function getAnalyticsInteractionDevice() {
    return WhatInput.ask();
}
//# sourceMappingURL=analyticsInteractionDevice.js.map